import { render, staticRenderFns } from "./OneNewsLayout.vue?vue&type=template&id=0e4e9fee&scoped=true&"
var script = {}
import style0 from "./OneNewsLayout.vue?vue&type=style&index=0&id=0e4e9fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e9fee",
  null
  
)

export default component.exports